import http from '@/utils/Http'

const BASE_PATH = '/v1/ai';

export default {
    namespaced: true,
    state: {
        messages: [],
        isSending: false,
        isMaximized: false
    },
    getters: {
        messages: state => state.messages,
        isSending: state => state.isSending,
        isMaximized: state => state.isMaximized
    },
    mutations: {
        async addMessage(state, payload) {
            state.messages.push(payload);
        },
        setMessages(state, payload) {
            state.messages = payload;
        },
        setMaximized(state, payload) {
            state.isMaximized = payload;
        },
        setSending(state, payload) {
            state.isSending = payload;
        }
    },
    actions: {
        async sendMessage({commit}, message) {
            commit('addMessage', message);
            commit('setSending', true)
            try {
                const {data} = await http.post(`${BASE_PATH}`, {
                    question: message.text,
                    type: message.type
                }, {
                    timeout: 1000 * 60 * 10
                });

                if (data.question_id && data.result) {
                    if (data.result.length >= 1) {
                        let array = data.result.filter(obj =>
                            Object.values(obj).some(valor => valor !== null && valor !== "")
                        );
                        const keys = Object.keys(array[0]);

                        commit('addMessage', {
                            text: keys.map(k => `<b>${k}</b>: ${array[0][k]}`).join('<br/>'),
                            result: data.result,
                            question_id: data.question_id,
                            from: 'agribot'}
                        );
                    }
                } else if (data.answer) {
                    commit('addMessage', {
                        text: data.answer,
                        question_id: data.question_id,
                        from: 'agribot'
                    });
                }

                return data
            } catch (e) {
                console.error('Falha no envio da mensagem', e);
                commit('addMessage', {text: 'Desculpe, não consegui entender a sua pergunta. Por favor, tente novamente.', from: 'agribot'});
                throw e
            } finally {
                commit('setSending', false);
            }

            return true
        },
        clearMessages({commit}) {
            commit('setMessages', []);
        },
        toggleMaximized({commit}, value) {
            commit('setMaximized', value);
        },
        toggleSending({commit}, value) {
            commit('setSending', value);
        }
    }
}